import { useState } from 'react';
import { MobBottomSheet } from '../../components/mob';
import { useSession } from '../../auth/useSession';
import './HeaderUserMenu.css';

function initialsFrom(name?: string | null): string {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  const first = parts[0][0] ?? '';
  const last = parts.length > 1 ? (parts[parts.length - 1][0] ?? '') : '';
  const both = (first + last).toUpperCase();
  return both || '?';
}

export function HeaderUserMenu() {
  const [open, setOpen] = useState(false);
  const { session, logout } = useSession();

  const displayName =
    session?.user?.fullName ?? session?.user?.username ?? 'Signed in';
  const secondary = session?.user?.email ?? (
    session?.user?.username ? `@${session.user.username}` : null
  );
  const roles = session?.user?.roles ?? [];
  const initials = initialsFrom(displayName);

  const env = import.meta.env.VITE_APP_ENV;
  const version = `v0.1.0${env !== 'production' ? ` · ${env}` : ''}`;

  return (
    <>
      <button
        type="button"
        className="header-avatar"
        aria-label="Open user menu"
        onClick={() => setOpen(true)}
      >
        {initials}
      </button>

      <MobBottomSheet
        isOpen={open}
        onClose={() => setOpen(false)}
        ariaLabel="User menu"
      >
        <div className="user-menu">
          <div className="user-menu__ident">
            <div className="user-menu__avatar" aria-hidden="true">{initials}</div>
            <div className="user-menu__ident-txt">
              <div className="user-menu__name">{displayName}</div>
              {secondary ? (
                <div className="user-menu__meta">{secondary}</div>
              ) : null}
              {roles.length > 0 ? (
                <div className="user-menu__roles">
                  {roles.map((r) => (
                    <span key={r} className="user-menu__role">{r}</span>
                  ))}
                </div>
              ) : null}
            </div>
          </div>

          <div className="user-menu__list">
            <button
              type="button"
              className="user-menu__item"
              disabled
              aria-disabled="true"
            >
              <span className="user-menu__item-lbl">
                <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="8" r="4" />
                  <path d="M4 21c0-4 4-6 8-6s8 2 8 6" />
                </svg>
                Profile
              </span>
              <span className="user-menu__pill">Coming soon</span>
            </button>

            <button
              type="button"
              className="user-menu__item user-menu__item--danger"
              onClick={() => {
                setOpen(false);
                void logout();
              }}
            >
              <span className="user-menu__item-lbl">
                <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                  <polyline points="16 17 21 12 16 7" />
                  <line x1="21" y1="12" x2="9" y2="12" />
                </svg>
                Sign out
              </span>
            </button>
          </div>

          <div className="user-menu__foot">CRS Mobile · {version}</div>
        </div>
      </MobBottomSheet>
    </>
  );
}
